import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './Subscription1.css';

const Subscription1 = () => {
  const location = useLocation();
  const { formData, selectedDate, selectedTime, selectedPlan, treatment } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([
    {
      id: 1,
      name: 'Short-Term Program',
      price: '₹999',
      description: 'Achieve Lasting Health',
      details: [
        'A diet plan for a week created by senior nutritionists at D\'Organics',
        'Private access to educational material based on recent research',
        '15 Restaurant guides',
        'Dessert and emotional cleansing guides',
      ],
      active: false,
    },
  ]);
  const [selectedPlanState, setSelectedPlan] = useState(null);

  // Log the form data and booking details
  console.log('Form Data:', formData);
  console.log('Selected Date:', selectedDate);
  console.log('Selected Time:', selectedTime);
  console.log('Selected Plan from PackageBooking:', selectedPlan);

  console.log('Selected Treatment:', treatment);

  const handlePlanSelection = async (planId) => {
    // Update plans to reflect the active selection
    const updatedPlans = plans.map((plan) => ({
      ...plan,
      active: plan.id === planId,
    }));
    setPlans(updatedPlans);

    // Find and set the selected plan
    const plan = updatedPlans.find((plan) => plan.active);
    setSelectedPlan(plan);
    console.log('Selected Plan:', plan);

    if (!formData?.name || !formData?.phone || !formData?.email) {
      alert('Missing user information. Please fill in all required fields.');
      return;
    }

    setLoading(true);
    try {
      const subscriptionDetails = `${plan.name} - ${plan.description}`;
      console.log('Subscription Details:', subscriptionDetails);

      const paymentData = {
        transactionId: `TX_${Date.now()}`,
        MUID: formData.email.split('@')[0] || 'user',
        name: formData.name,
        amount: parseInt(plan.price.replace(/[₹,]/g, ''), 10),
        number: formData.phone,
        email: formData.email,
        treatment: treatment || 'N/A',
        subscriptionDetails,
      };

      console.log('Payment payload:', paymentData);

      const response = await axios.post(
        'https://54n24jytpd.execute-api.ap-south-1.amazonaws.com/prod/order',
        paymentData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Full API response:', response);

      if (response.data.success && response.data.data?.instrumentResponse?.redirectInfo?.url) {
        window.location.href = response.data.data.instrumentResponse.redirectInfo.url;
      } else {
        throw new Error('Payment URL not received from server');
      }
    } catch (error) {
      console.error('Payment error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      alert('Payment failed: ' + (error.response?.data?.message || error.message || 'Unknown error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="package-container">
      <h2>You are booking: Consultation</h2>
      <p>{`${selectedDate} ${selectedTime}`}</p>

      <div className="plans">
        {plans.map((plan) => (
          <div
            key={plan.id}
            className={`plan ${plan.active ? 'active' : ''} ${loading ? 'disabled' : ''}`}
          >
            <h3>{plan.name}</h3>
            <p>{plan.description}</p>
            <p><strong>{plan.price}</strong></p>
            {plan.details && (
              <ul className="plan-details">
                {plan.details.map((detail, index) => (
                  <li key={index}>{detail}</li>
                ))}
              </ul>
            )}
            <button
              className="select-button"
              onClick={() => handlePlanSelection(plan.id)}
              disabled={loading}
            >
              {loading && plan.active ? 'Processing...' : 'Select Plan'}
            </button>
            {loading && plan.active && <div className="loading-indicator">Processing...</div>}
          </div>
        ))}
      </div>

      {selectedPlanState && (
        <div className="selected-plan-details">
          <h3>Selected Plan Details</h3>
          <p><strong>Name:</strong> {selectedPlanState.name}</p>
          <p><strong>Price:</strong> {selectedPlanState.price}</p>
          <p><strong>Description:</strong> {selectedPlanState.description}</p>
        </div>
      )}
    </div>
  );
};

export default Subscription1;